import { SwitchTransition, Transition } from "react-transition-group";

let reducedMotion = false;

if (typeof window !== "undefined") {
  reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

const defaultTransitionStyle = {
  transition: "transform 200ms ease, opacity 200ms ease",
};

const transitionStyles: any = {
  entering: {
    opacity: 0,
    transform: "translateY(calc(-10%))",
    ...defaultTransitionStyle,
  },
  entered: {
    opacity: 1,
    transform: "translateY(0)",
    ...defaultTransitionStyle,
  },
  exiting: {
    opacity: 0,
    ...defaultTransitionStyle,
  },
  exited: {
    opacity: 0,
    ...defaultTransitionStyle,
  },
  timeout: 200,
};

const Fade = ({ state, children }: any) => {
  if (reducedMotion) {
    return (
      <div className="relative" key={state}>
        {children || null}
      </div>
    );
  }
  return (
    <SwitchTransition>
      <Transition timeout={200} key={state} appear={state > 0}>
        {(state) => (
          <div
            className="h-full flex flex-col grow"
            style={{
              ...transitionStyles[state],
            }}
          >
            {children}
          </div>
        )}
      </Transition>
    </SwitchTransition>
  );
};

export default Fade;
